<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>采购申请详情</span>
      </div>
      <div class="common head-wrapper">
        <div class="layout row">
          <label>采购申请详情：</label>
          <span class="flex-1">{{requisition_info.requisition_num}}</span>
          <span class="green" v-if="requisition_info.status === 1">已入账</span>
          <span class="orange" v-else>未入账</span>
        </div>
        <div class="head-img">
          <img v-if="requisition_info.pictures" v-for="(pictures, pictures_key) in requisition_info.pictures" :key="pictures_key" :src="pictures.picture_url">
        </div>
        <div class="layout row">
          <label>备注：</label>
          <span class="flex-1">{{requisition_info.remark}}</span>
        </div>
      </div>
      <div class="common head-wrapper">
        <div class="head-goods">
          <span>商品种类：<span class="blue">{{requisition_info.goods_kind}}种</span></span>
          <span>总件数：<span class="blue">{{requisition_info.goods_count}}件</span></span>
        </div>
      </div>
      <div class="common goods-wrapper">
        <div class="table-head layout">
          <label class="flex-1">品名/条码</label>
          <label>数量</label>
        </div>
        <div class="layout" v-if="goods_lists" v-for="(goods, goods_key) in goods_lists" :key="goods_key">
          <label>1</label>
          <label v-if="goods.image_url"><img :src="goods.image_url"></label>
          <label v-else><img src="../../../assets/images/no-picture.jpg"></label>
          <label class="flex-1">
            <div class="name">{{goods.goods_name}}</div>
            <div class="name">{{goods.goods_num}}</div>
          </label>
          <label>{{goods.requisition_count}}</label>
        </div>
      </div>
      <div class="common record-wrapper" v-if="come_from_approval != 1">
        <div class="record-title">操作记录</div>
        <div class="record-row layout" v-if="operate_log" v-for="(operate, operate_key) in operate_log" :key="operate_key">
          <span>{{operate.operate_content}} {{operate.operate_time_info}}</span>
          <span class="flex-1">{{operate.operate_member_name}}</span>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom" v-if="requisition_status && come_from_approval != 1">
      <button class="entry-btn" @click="entryBtn" v-if="requisition_info.approval && requisition_info.approval.status == 3 || !requisition_info.approval && !requisition_info.approval_set">入账</button>
      <button class="edit-btn" @click="editBtn" v-if="!requisition_info.approval || requisition_info.approval && requisition_info.approval.status == 1">编辑</button>
      <button class="del-btn" @click="delBtn" v-if="!requisition_info.approval || requisition_info.approval && [1,4].indexOf(requisition_info.approval.status) >= 0">删除</button>
      <button class="entry-btn" @click="resubmitApproval()" v-if="requisition_info.approval && requisition_info.approval.status == 1">重新提交审批</button>
      <button class="entry-btn" @click="submitApproval()" v-if="!requisition_info.approval && requisition_info.approval_set">提交审批</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { submitApproval, resubmitApproval } from '../../../assets/js/approval.js'
export default {
  name: 'RequisitionDetail',
  metaInfo: {
    title: '采购申请详情'
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    console.log('this.$route.query:')
    console.log(this.$route.query)
    this.requisition_id = this.$route.query.requisition_id
    if (this.$route.query.come_from_approval) {
      this.come_from_approval = this.$route.query.come_from_approval
    }
    this.getRequisitionInfo()
    if (this.group_management_id === '') {
      this.axios.post('/wechat/Index/getVillageInfo', {
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          var getVillageInfo = res.data.data
          this.group_management_id = getVillageInfo.group_management_id
        }
      })
    }
  },
  data () {
    return {
      requisition_info: [],
      goods_lists: [],
      operate_log: [],
      requisition_status: false,
      come_from_approval: 0, // 审批页面调过来时传come_from_approval=1,不展示操作按钮
      group_management_id: ''
    }
  },
  methods: {
    // 审批
    submitApproval () {
      submitApproval(this, this.memberId, this.villageId, 2, this.requisition_info.requisition_id)
    },
    resubmitApproval () {
      resubmitApproval(this, this.memberId, this.villageId, this.requisition_info.approval.approval_id)
    },
    getRequisitionInfo () {
      this.axios.post('/wechat/Purchase/getRequisitionInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        requisition_id: this.requisition_id
      }).then((res) => {
        console.log('getRequisitionInfo:')
        console.log(res)
        if (res.data.status === 1) {
          this.requisition_info = res.data.data
          this.goods_lists = res.data.data.goods
          this.operate_log = res.data.data.operate_log
          if (this.requisition_info.status !== 1) {
            this.requisition_status = true
          }
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    editBtn () {
      console.log(this.requisition_info)
      console.log(this.requisition_info.requisition_type)
      if ([1, 11].indexOf(this.group_management_id) === -1) {
        this.$router.push({name: 'RequisitionSelecteGoods', query: {requisition_id: this.requisition_id}})
      } else {
        this.$router.push({name: 'RequisitionSelecteGoods', query: {requisition_id: this.requisition_id, requisition_type: this.requisition_info.requisition_type}})
      }
    },
    entryBtn () {
      this.operateFunction('/wechat/Purchase/enStorage')
    },
    delBtn () {
      this.$messagebox({
        message: '确定删除吗？',
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') { // 确认的回调
          this.operateFunction('/wechat/Purchase/delRequisition')
        }
      })
    },
    operateFunction (url = '') {
      if (url === '') {
        this.$toast({
          message: '参数错误',
          duration: 5000
        })
        return false
      }
      if (this.requisition_id === 0 || this.requisition_id === undefined) {
        this.$toast({
          message: '未选择单据',
          duration: 5000
        })
        return false
      }
      this.axios.post(url, {
        member_id: this.memberId,
        village_id: this.villageId,
        requisition_id: this.requisition_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '操作成功',
            duration: 5000
          })
          this.$router.push({name: 'RequisitionList'})
        } else {
          this.$toast({
            message: res.data.message,
            duration: 5000
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 25px;
}
.head-wrapper .row label {
  width: 125px;
  color: #8c8c8c;
}
.head-wrapper .head-img img {
  width: 60px;
  height: 60px;
  margin: 10px 5px 10px 0 ;
}
.head-wrapper .head-goods {
  color: #8c8c8c;
}
.head-wrapper .head-goods span.blue {
  padding-right: 15px;
}
.goods-wrapper {
  font-size: 15px
}
.goods-wrapper .table-head {
  border-bottom: 1px solid #e9e9e9;
  color: #8c8c8c;
}
.goods-wrapper .table-head label {
  height: 35px;
  line-height: 35px;
}
.goods-wrapper img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
  padding-right: 10px;
}
.goods-wrapper label {
  min-width: 25px;
  height: 50px;
  line-height: 50px;
}
.goods-wrapper label .name {
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.goods-wrapper label .name:first-child {
  margin-top: 8px;
}
.record-wrapper {
  font-size: 15px;
}
.record-wrapper .record-title {
  font-weight: 700;
}
.record-wrapper .record-row {
  margin-top: 8px;
}
.record-wrapper .record-row .flex-1 {
  text-align: right;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  padding: 10px 15px;
}
.backdrop-bottom button {
  height: 30px;
  line-height: 29px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid #7c7b80;
  color: #7c7b80;
  font-size: 14px;
  padding: 0 14px;
  float: right;
  margin-left: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  border: 1px solid #ff7c12;
  color: #ffffff;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.layout .flex-2 {
  flex: 2;
}
.green {
  color: #35c53b;
}
.blue {
  color: #25ade0;
}
.orange {
  color: #fa6b2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/purchase/RequisitionDetail.vue